import dayjs from 'dayjs';
import { FC } from 'react';
import NoResponseIcon from '@/assets/wellbeing-response/negative-no-help-response.svg';
import NegativeResponseNoHelpIcon from '@/assets/wellbeing-response/negative-with-help-response.svg';
import NegativeResponseWithHelpIcon from '@/assets/wellbeing-response/no-response.svg';
import PositiveResponseIcon from '@/assets/wellbeing-response/positive-response.svg';
import { Response } from '@/types/wellbeing-response';
import { cx } from '@/utils/cx';
import { getTimeString } from '@/utils/wellbeing-response/get-time-string';
import { getWellbeingResponseText } from '@/utils/wellbeing-response/get-wellbeing-response-text';

export type ResponseListItemProps = {
  response: Response;
  isLast?: boolean;
};

export const ResponseListItem: FC<ResponseListItemProps> = ({
  response,
  isLast,
}) => {
  const sentTimeStamp = getTimeString(dayjs(response.sendTimeStamp));
  const receivedTimeStamp = getTimeString(
    dayjs(response.responseTimeStamp ?? 0),
  );

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <div
          className={cx(
            'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-400 text-white',
            response.response === 'PositiveResponse' && 'bg-green-500',
            response.response === 'NegativeNoHelp' && 'bg-red-500',
            response.response === 'NegativeWithHelp' && 'bg-yellow-500',
          )}
        >
          {response.response === 'NoResponse' && <NoResponseIcon />}
          {response.response === 'PositiveResponse' && <PositiveResponseIcon />}
          {response.response === 'NegativeNoHelp' && (
            <NegativeResponseNoHelpIcon />
          )}
          {response.response === 'NegativeWithHelp' && (
            <NegativeResponseWithHelpIcon />
          )}
        </div>
        <div className="flex min-w-96 max-w-[27.5rem] flex-grow flex-row items-center justify-between gap-4 pl-3 text-sm text-gray-500">
          <div>{getWellbeingResponseText(response)}</div>
          <div>{`Notification text: ${response.payload}`}</div>
          <div>Sent at {sentTimeStamp}</div>
          {response.response != 'NoResponse' && (
            <div>Received at {receivedTimeStamp}</div>
          )}
        </div>
      </div>
      <div className="h-8">
        {!isLast && <div className="mx-4 my-2 h-4 w-0.5 bg-gray-200"></div>}
      </div>
    </div>
  );
};
